export default __webpack_public_path__ + "static/media/5090.4fbeebf2.png";